import React, { Component } from 'react';
import { connect } from "react-redux";

import {
  PROGRAM_ADN,
  PROGRAM_PT
} from "../config/constants";

import EducationRequirementsPT from "./EducationRequirementsPT";
import EducationRequirementsADN from "./EducationRequirementsADN";

class EducationRequirements extends Component {
  render() {
    switch (this.props.programId) {
      case (PROGRAM_ADN):
        return (
          <EducationRequirementsADN />
        );
      case (PROGRAM_PT):
        return (
          <EducationRequirementsPT />
        );
      default:
        return (
          <div>Unknown Program</div>
        )
    }

  };
}

export default connect(
  (state) => {
    const { appInfo } = state;
    const { programId } = appInfo.application;
    return {
      programId
    };
  }
)(EducationRequirements);